<template>
  <img
    class="cloud"
    src="@/app/common/assets/cloud.png"
    :style="`animation-duration: ${duration}s`"
    alt="cloud"
  />
</template>

<script>
import CloudCaneLeft from "@/app/common/assets/cloud_cane_left.svg?url";
import CloudCaneRight from "@/app/common/assets/cloud_cane_right.svg?url";
import CloudShowmanLeft from "@/app/common/assets/cloud_showman_left.svg?url";
import CloudShowmanRight from "@/app/common/assets/cloud_showman_right.svg?url";
import CloudDefault from "@/app/common/assets/cloud.png?url";

export default {
  props: {
    duration: { required: false, type: Number, default: 4 },
    image: { required: false, type: String, default: null },
  },
  methods: {
    imageChannel() {
      let url = CloudDefault;

      console.log(this.image,"image");
      if (this.image === "cane_left") {
        url = CloudCaneLeft;
      } else if (this.image === "cane_right") {
        url = CloudCaneRight;
      } else if (this.image === "showman_left") {
        url = CloudShowmanLeft;
      } else if (this.image === "showman_right") {
        url = CloudShowmanRight;
      }
      return url;
    },
  },
};
</script>

<style lang="sass" scoped>
.cloud
  display: block
  opacity: 0.15
  user-select: none
  animation: floating infinite linear

@keyframes floating
  0%, 100%
    opacity: 0.15
    transform: translateY(2.5rem) scale(1)
  30%
    opacity: 0.1
  50%
    transform: translateY(0) scale(1.1)
</style>
